import React, { Component } from 'react';
import { Link } from 'react-router';
import idx from 'idx';
import SubCategoryTestimonial from 'marketing/containers/sub_category_testimonial';
import PricingDifferentiators from 'marketing/containers/pricing_differentiators';
import ReviewsAgg from 'marketing/containers/reviews_agg';
import Packages from 'pap/components/common/input_fields/packages';

export default class PackageSelectorInput extends Component {
  componentWillUnmount() {
    this.props.hideFullScreen();
  }

  render() {
    const {
      subCategory, showTestimonial, showDifferentiators, showReviewsAgg, showCta,
    } = this.props;

    return (
      <div className="package-selector">
        <Packages {...this.props} />

        { showCta &&
        <div className="text-center cta">
          <Link className="btn btn-primary btn-lg" to="/start-a-project/">Get started</Link>
        </div> }

        { showReviewsAgg &&
        <div className="row text-center">
          <div className="columns small-16">
            <ReviewsAgg />
          </div>
        </div> }

        <div className="row text-center">
          <div className="columns small-16 large-8 large-offset-4 medium-10 medium-offset-3">
            { showTestimonial && <SubCategoryTestimonial subcatId={idx(subCategory, _ => _.id)} /> }
          </div>
        </div>

        { showDifferentiators && <PricingDifferentiators subcatId={idx(subCategory, _ => _.id)} /> }
      </div>
    )
  }
};
